import { Helmet } from "react-helmet-async";

export const Favicon = () => {
	return (
		<Helmet>
			<link rel="apple-touch-icon-precomposed" sizes="57x57" href="/dist/client/favicon/apple-touch-icon-57x57.png" />
			<link rel="apple-touch-icon-precomposed" sizes="114x114" href="/dist/client/favicon/apple-touch-icon-114x114.png" />
			<link rel="apple-touch-icon-precomposed" sizes="72x72" href="/dist/client/favicon/apple-touch-icon-72x72.png" />
			<link rel="apple-touch-icon-precomposed" sizes="144x144" href="/dist/client/favicon/apple-touch-icon-144x144.png" />
			<link rel="apple-touch-icon-precomposed" sizes="60x60" href="/dist/client/favicon/apple-touch-icon-60x60.png" />
			<link rel="apple-touch-icon-precomposed" sizes="120x120" href="/dist/client/favicon/apple-touch-icon-120x120.png" />
			<link rel="apple-touch-icon-precomposed" sizes="76x76" href="/dist/client/favicon/apple-touch-icon-76x76.png" />
			<link rel="apple-touch-icon-precomposed" sizes="152x152" href="/dist/client/favicon/apple-touch-icon-152x152.png" />
			<link rel="icon" type="image/png" href="/dist/client/favicon/favicon-196x196.png" />
			<link rel="icon" type="image/png" href="/dist/client/favicon/favicon-96x96.png" />
			<link rel="icon" type="image/png" href="/dist/client/favicon/favicon-32x32.png" />
			<link rel="icon" type="image/png" href="/dist/client/favicon/favicon-16x16.png" />
			<link rel="icon" type="image/png" href="/dist/client/favicon/favicon-128.png" />
			<meta name="application-name" content="Saudi Aramco" />
			<meta name="msapplication-TileColor" content="#FFFFFF" />
			<meta name="msapplication-TileImage" content="/dist/client/favicon/mstile-144x144.png" />
			<meta name="msapplication-square70x70logo" content="/dist/client/favicon/mstile-70x70.png" />
			<meta name="msapplication-square150x150logo" content="/dist/client/favicon/mstile-150x150.png" />
			<meta name="msapplication-wide310x150logo" content="/dist/client/favicon/mstile-310x150.png" />
			<meta name="msapplication-square310x310logo" content="/dist/client/favicon/mstile-310x310.png" />
		</Helmet>
	)
}
